import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { Direction, Operator, OutboundMessageType } from "./enums";

export const PolicyCondition = Type.Union([
  Type.Object({ type: Type.Literal("user"), userId: Type.Array(Type.String()) }),
  Type.Object({ type: Type.Literal("internal_users"), include: Type.Boolean() }),
  Type.Object({ type: Type.Literal("group"), groupId: Type.Array(Type.String()) }),
  Type.Object({ type: Type.Literal("mimeType"), mimeType: Type.Array(Type.String()) }),
  Type.Object({
    type: Type.Literal("fileSize"),
    maxSize: Type.Optional(Type.Number()),
    size: Type.Optional(Type.Number()),
    operator: Type.Optional(
      Type.Union([Type.Literal(Operator.GT), Type.Literal(Operator.LT), Type.Literal(Operator.GTE), Type.Literal(Operator.LTE)])
    ),
  }),
  Type.Object({
    type: Type.Literal("direction"),
    direction: Type.Literal(Direction.OUTBOUND),
    msgType: Type.Optional(Type.Array(Type.Enum(OutboundMessageType))),
  }),
  Type.Object({
    type: Type.Literal("direction"),
    direction: Type.Union([Type.Literal(Direction.INBOUND), Type.Literal(Direction.UPLOAD), Type.Literal(Direction.DOWNLOAD)]),
  }),
  Type.Object({ type: Type.Literal("template") }),
  Type.Object({ type: Type.Literal("devtools") }),
  Type.Object({ type: Type.Literal("rule"), id: Type.Union([Type.String(), Type.Array(Type.String())]) }),
]);

export type PolicyCondition = TypeBoxToType<typeof PolicyCondition>;
